<template>
  <div class="afterSales">
    <TablePage ref="list" @page-change="pageHandler" :total="total">
      <table>
        <tr class="t-header">
          <th class="t-g">订单商品 Order item</th>
          <th class="t-s">申请/实退金额 Amount</th>
          <th class="t-m">当前进度 Progress</th>
          <th class="t-o">操作 Operation</th>
        </tr>
        <div v-for="item in orderList" :key="item.id" class="t-order">
          <tr class="t-order-info fl-align-center">
            <th class="primary-text" style="margin-left:30px">申请时间 Application time：{{ item.refundTime }}</th>
            <th class="primary-text">订单编号 Order number：{{ item.orderStoreNo }}</th>
          </tr>
          <tr class="t-order-content">
            <td class="t-a">
              <div class="goods-item">
                <div class="good-image">
                  <el-image :src="item.coverImage"></el-image>
                </div>
                <div class="good-info">
                  <p class="primary-text sl-ellipsis">{{ item.name }}</p>
                  <p class="primary-text sl-ellipsis">{{ item.nameEn }}</p>
                  <div class="good-spec">规格：{{ item.spec || "单规格" }}</div>
                </div>
              </div>
            </td>
            <td class="t-s">
              <div class="t-s-d">
                <p>￥{{ item.price }}</p>
              </div>
            </td>
            <td class="t-m primary-text">
              <p v-if="item.refundStatus == 3">退款 refund：{{ item.refundAmount }}</p>
              <!-- <p v-if="item.refundAudit == 1">实退：{{ item.realRefundAmount }}</p> -->
            </td>
            <td class="t-m primary-text">
              <p>{{ item.refundChNameNotag }}</p>
              <p>{{ item.refundEnNameNotag }}</p>
            </td>
            <td class="t-b primary-text" @click="salesDetailClick(item)">
              <p>订单详情</p>
              <p>Order details</p>
            </td>
          </tr>
        </div>
      </table>
    </TablePage>
  </div>
</template>

<script>
import TablePage from "@/components/base/TablePage";
export default {
  name: "order",
  components: { TablePage },
  data() {
    return {
      orderList: [],
      total: 0,
      refundState: {
        0: {
          chName: "提交成功",
          enName: "Submit successfully",
        },
        1: {
          chName: "审核成功",
          enName: "Audit successful",
        },
        2: {
          chName: "审核驳回",
          enName: "Audit rejection",
        },
        3: {
          chName: "退款成功",
          enName: "Refund successful",
        },
        4: {
          chName: "退款失败",
          enName: "Refund fail",
        },
        5: {
          chName: "取消退款",
          enName: "Refund cancel",
        },
      },
    };
  },
  props: {},
  computed: {},
  async mounted() {
    this.searchHandler();
  },
  methods: {
    //初始化查询
    searchHandler() {
      this.$refs.list.reset();
    },
    async pageHandler(page, pageSize) {
      const params = {
        page: page,
        pageSize: pageSize,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getRefundList(params);
        this.orderList = list.map((item) => {
          item.refundChNameNotag = this.refundState[item.refundStatus].chName;
          item.refundEnNameNotag = this.refundState[item.refundStatus].enName;
          return item;
        });
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
    async salesDetailClick(item) {
      this.$router.push({
        path: "/my-profile/after-sales/detail",
        query: {
          id: item.id,
          orderStoreNo:item.orderStoreNo
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.afterSales {
  margin-top: 25px;
}
table {
  width: 100%;
  margin-top: 20px;
  .t-header {
    height: 50px;
    background: #fcfcfc;
    border: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    > th {
      white-space: nowrap;
      flex: none;
    }
  }
  .t-g {
    width: 590px;
  }
  .t-a {
    width: 430px;
  }
  .t-s {
    width: 160px;
  }
  .t-m {
    width: 160px;
    border-right: 1px solid #f0f0f0;
    p {
      text-align: center;
      line-height: 1.5;
    }
  }
  .t-b {
    width: 160px;
    margin-top: 30px;
    cursor: pointer;
    p {
      text-align: center;
      line-height: 1.5;
    }
  }
  .t-o {
    text-align: center;
    flex: 1;
  }
  .t-order-info {
    height: 50px;
    background: #ffffff;
    border: 1px solid #f0f0f0;
    th {
      margin-left: 100px;
    }
  }
}
.t-order-content {
  background: #fcfcfc;
  display: flex;
  border-left: 1px solid #f0f0f0;
  border-right: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  td {
    box-sizing: border-box;
  }
  .goods-item {
    display: flex;
    align-items: flex-start;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid #f0f0f0;
    border-bottom: 0;
    .good-info {
      flex: 1;
      p {
        width: 400px;
      }
      .good-spec {
        margin-top: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
      }
      .good-price {
        margin-top: 16px;
      }
    }
    .good-image .el-image {
      width: 88px;
      height: 88px;
      display: block;
      margin-left: 32px;
      margin-right: 20px;
    }
  }
  .t-s {
    padding: 30px 20px 0;
    border-right: 1px solid #f0f0f0;
  }
  .t-m {
    padding-top: 30px;
  }
  .t-o {
    flex: 1;
    display: flex;
    justify-content: center;
    padding-top: 30px;
  }
}
.t-order:last-child .t-g .goods-item:last-child {
  border-bottom: 1px solid #f0f0f0;
}
</style>
